export const searchUnits = {
  "* Touch the clinic's name on the map to see the details":
    '* Toque el nombre de la clínica en el mapa para ver los detalles',
  'Activate location': 'Activar ubicación',
  'Activate the location to find the ideal clinic more quickly':
    'Active la ubicación para encontrar la clínica ideal más rápidamente',
  City: 'Ciudad',
  'Find a Clinic': 'Encuentre una Clínica',
  'Find clinics': 'Buscar unidades',
  'Find the ideal clinic to start living without hair':
    'Encuentre la clínica ideal para empezar a vivir la vida sin vellos',
  'Find the nearest clinic': 'Encuentre la clínica más cercana a usted',
  Select: 'Seleccione',
  'Select the state and the city to find the ideal Vialaser unit for you':
    'Seleccione el estado y la ciudad para encontrar la unidad Vialaser ideal para usted',
  State: 'Estado',
  'Find the nearest unit': 'encontrar la unidad más cercana',
  'Find the nearest Vialaser location and visit our clinic. Laser hair removal with advanced technology and specialized service.':
    'Encuentra la sucursal de Vialaser más cercana y visita nuestra clínica. Depilación láser con tecnología avanzada y servicio especializado.',
  'Vialaser units, laser hair removal near me, hair removal clinic':
    'Unidades de Vialaser, depilación láser cerca de mí, clínica de depilación láser',
  'Laser hair removal': 'Depilación láser',
};
